import MyTimeline from './module/MyTimeline';
import MyLoading from './module/MyLoading';
import showTimelineItems from './module/showTimelineItems';
import showArticle from './module/showArticle';
import intro from './module/intro';
import {fadeIn, fadeOut} from './module/fade';
import bookmarkFill from './module/bookmarkFill';


//タイムラインページ用
(function() {
	const loading = new MyLoading();
	loading.watch();

	const timeline = new MyTimeline('js-wrap-timeline');
	const timelineEl = timeline.getElement();
	const articleArea = document.getElementById('js-articlearea');
	const articleWrapper = document.getElementById('js-wraparticlearea');
	const closeBtn = document.getElementById('js-articlearea-close');
	const prevEl = document.getElementById('js-prev');
	const nextEl = document.getElementById('js-next');
	const loadingEl = document.getElementById('js-loading');
	const headerEl = document.getElementById('js-header');

	let scrollPos = 0;
	let fixScrollPos = 0;
	let startX, startY;
	let showCount = 0;
	let footLoadPoint = 10000;
	let isTimelineLoadPending = false;
	let footerH;
	let nextElH = 0;

	//記事詳細を閉じる関数
	function closeArticle() {
		timelineEl.classList.remove('is-fix');
		timelineEl.style.top = 0;
		window.scrollTo(0, fixScrollPos);
		articleWrapper.classList.remove('is-show');
		isTimelineLoadPending = false;
		setTimeout(function() {
			headerEl.classList.remove('is-visible');
		}, 500);
	}

	//イベントリスナー追加

	//タイムラインの中にコンテンツを入れる
	timelineEl.addEventListener('created', (e) => {
		showTimelineItems(timeline, e.detail.el);
	});
	timelineEl.addEventListener('addedBottom', (e) => {
		showTimelineItems(timeline, e.detail.el, 'bottom');
	});
	timelineEl.addEventListener('addedTop', (e) => {
		showTimelineItems(timeline, e.detail.el, 'top');
		const myEl = e.detail.el;
		myEl.classList.add('is-waiting');
		window.addEventListener('timelineLoaded', (e) => {
			myEl.classList.remove('is-waiting');
			window.scrollTo(0, myEl.offsetHeight + scrollPos - nextElH);
		}, { once: true });
	});
	//タイムラインの状態
	window.addEventListener('timelineReady', (e) => {
		bookmarkFill('#js-wrap-timeline');
	});
	window.addEventListener('timelineLoaded', (e) => {
		const scTop = window.pageYOffset || document.documentElement.scrollTop;
		const top = prevEl.getBoundingClientRect().top;

		// 読み込み完了後にスクロール位置を移動
		// if(e.detail.distance && e.detail.distance == 'top') {
		// 	window.scrollTo(0, e.detail.el.offsetHeight + scrollPos);
		// }
		//初めだけ該当の箇所へスクロール
		const headerH = headerEl.offsetHeight;
		if(showCount < 1) {
			let currentEl;
			let currentDateEl;
			if(!location.hash) {
				//今日の日付に移動
				const date = new Date();
				const year = date.getFullYear();
				let month = date.getMonth() + 1;
				month = (month < 10)? "0"+month : month;
				let day = date.getDate();
				day = (day < 10)? "0"+day : day;
				const targetId = "d-"+year+"-"+month+"-"+day;
				currentEl = document.getElementById(targetId);
				currentDateEl = currentEl;
				if(currentEl) {
					let celTop = currentEl.getBoundingClientRect().top;
					window.scrollTo(0, celTop + scTop - headerH);
				} else {
					console.log(targetId+' is not found');
				}
			} else {
				//日付指定あり
				currentEl = document.querySelector(location.hash);
				currentDateEl = currentEl;
				//日付に移動
				if(currentEl) {
					let celTop = currentEl.getBoundingClientRect().top;
					window.scrollTo(0, celTop + scTop - headerH);
				} else {
					console.log(location.hash+' is not found');
				}
			}
			//イントロ
			intro();
		}

		showCount += 1;

		//前月の読み込み位置取得
		footLoadPoint = scTop + top - window.innerHeight;
		isTimelineLoadPending = false;
		setTimeout(function() {
			loadingEl.classList.remove('is-invisible');
		}, 500);
	});

	//詳細読み込み完了
	window.addEventListener('articleLoaded', (e) => {
		bookmarkFill('#js-article');
		setTimeout(function() {
			loadingEl.classList.remove('is-bg-transparent');
		}, 500);
	});
	//詳細表示時タイムラインを固定
	articleWrapper.addEventListener('transitionend', (e) => {
		if(e.target.classList.contains('is-show')) {
			const footerEl = document.getElementById('js-footer');
			footerH = footerEl.offsetHeight;
			fixScrollPos = window.pageYOffset || document.documentElement.scrollTop;
			timelineEl.classList.add('is-fix');
			timelineEl.style.top = (fixScrollPos * -1) + 'px';
		} else {
		}
	});
	//詳細情報を閉じる
	if(closeBtn) {
		closeBtn.addEventListener('click', closeArticle);
	}
	//タッチでスクロール無効
	closeBtn.addEventListener('touchmove', (e) => {
		e.preventDefault();
	});
	//詳細情報をスワイプで閉じる
	articleArea.addEventListener('touchstart', (e) => {
		const obj = e.changedTouches[0];
		startX = obj.pageX;
		startY = obj.pageY;
	});
	articleArea.addEventListener('touchmove', (e) => {
		const obj = e.changedTouches[0];
		const x = Math.abs(startX - obj.pageX);
		const xDistance = startX - obj.pageX;
		const y = Math.abs(startY - obj.pageY);
		if(x > y) {
			//横にスワイプ
			if(x < 50) {
				return;
			}
			closeArticle();
		}
	});

	//無限読み込み
	window.addEventListener('scroll', (e) => {
		const scTop = window.pageYOffset || document.documentElement.scrollTop;
		scrollPos = scTop;
		if(scTop <= 0 && nextEl.classList.contains('is-active')) {
			if(!isTimelineLoadPending) {
				isTimelineLoadPending = true;
				nextElH = nextEl.offsetHeight;
				saveScrollTop = scTop;
				const nextDate = timeline.getNextDate();
				console.log(nextDate);
				loadingEl.classList.add('is-invisible');
				timeline.addTop(nextDate.year, nextDate.month);
			}
		}
		if(scTop >= footLoadPoint && prevEl.classList.contains('is-active')) {
			if(!isTimelineLoadPending) {
				isTimelineLoadPending = true;
				saveScrollTop = scTop;
				const prevDate = timeline.getPrevDate();
				console.log(prevDate);
				loadingEl.classList.add('is-invisible');
				timeline.addBottom(prevDate.year, prevDate.month);
			}
		}

	});

	//詳細情報を表示
	timelineEl.addEventListener('click', (e) => {
		loadingEl.classList.add('is-bg-transparent');
		headerEl.classList.add('is-visible');
		isTimelineLoadPending = true;
		showArticle(e, articleArea, articleWrapper);
	});

	//再保の処理 タイムライン生成 ハッシュがあれば指定の年限つになければ今月に
	if(location.hash) {
		const reqDate = location.hash.split('-');
		const dispYear = reqDate[1];
		const dispMonth = parseInt(reqDate[2]);
		timeline.create(dispYear, dispMonth);
	} else {
		timeline.create();
	}
})();
